<template>
  <div id="modal_models" class="modal" :class="{'is-active':show}">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"></p>
        <button class="delete" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">
        <div class="card" v-if="show">
          <div class="card-image p-2">
            <agile v-if="model.count_img>1" :nav-buttons="false" :autoplay-speed="5000" :speed="1500" fade="fade" pause-on-hover="pause-on-hover" pause-on-dots-hover="pause-on-dots-hover" autoplay="autoplay">
              <div class="slide" v-for="(img,key) in model.images" :key="key">
                <img :src="idiom+img.path"/>
              </div>
            </agile>
            <div class="slide" v-else>
              <img :src="idiom+model.primary_img"/>
            </div>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <figure class="image is-64x64">
                  <img :src="idiom+model.primary_img" style="height:70px; object-fit:cover; border:1px solid #f3f1f1;">
                </figure>
              </div>
              <div class="media-content">
                <p class="title is-size-4-desktop is-size-6-touch">{{model.fname}} {{model.lname}}</p>
                <p class="subtitle is-size-6-desktop is-size-7-touch">{{model.ethnicities}}</p>
              </div>
              <div class="media-right" v-if="model.count_img>1">
                <small class="is-size-7">{{model.count_img}} <i class="fas fa-images"></i></small>
              </div>
            </div>
            <div class="content">
              <p v-if="model.age_to">Age Range : {{model.age_begin}} - {{model.age_to}}</p>
              <p v-if="model.country">Country : {{model.country}}</p>
              <p v-if="model.city">City : {{model.city}}</p>
              <p v-if="model.states">States : {{model.states}}</p>
              <span class="tag is-link is-light mt-2 mr-1" v-if="model.gender"
                @click="hashTag(model,'gender')">#{{(model.gender==1?"Male":"Female")}}</span>
              <span class="tag is-link is-light mt-2 mr-1" v-if="model.age_to"
                @click="hashTag(model,'age_range')">{{text_age_tag(model)}}</span>
              <span class="tag is-link is-light mt-2 mr-1" v-if="model.country"
                @click="hashTag(model,'country')">#{{model.country}}</span>
              <span class="tag is-link is-light mt-2 mr-1" v-if="model.city"
                @click="hashTag(model,'city')">#{{model.city}}</span>
              <span class="tag is-link is-light mt-2 mr-1" v-if="model.states"
                @click="hashTag(model,'states')">#{{model.states}}</span>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <!-- <button class="button is-success">Save changes</button> -->
        <!-- <button class="button" @click="$emit('close')">Cancel</button> -->
      </footer>
    </div>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'

export default {
  name: 'ModalModels',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    model: Object,
  },
  components: { agile: VueAgile, },
  methods:{
    hashTag(model,option){
      console.log(model.fname,option);
      return null;
      // switch (option) {
      //   case "gender":
      //     if(model.gender==1){
      //       this.filter = "male"
      //     }else if(model.gender==2){
      //       this.filter = "female"
      //     }
      //     break;
      //   case "age_range":
      //     if(parseInt(model.age_to)==99){
      //       this.filter = "65+";
      //     }else{
      //       this.filter = model.age_begin+"to"+model.age_to;
      //     }
      //     break;
      //   case "country":
      //     this.filter = model.country.toLowerCase();
      //     break;
      //   case "city":
      //     this.filter = model.city.toLowerCase();
      //     break;
      //   case "states":
      //     this.filter = model.states.toLowerCase();
      //     break;
      // }
    },
    text_age_tag(model){
      if(parseInt(model.age_to)==99){
        return "#65+";
      }else{
        return "#"+model.age_begin+"to"+model.age_to;
      }
    }
  }
}
</script>

<style media="screen">
#modal_models .agile__dots {
bottom: 5px;
-webkit-box-orient: vertical;
-webkit-box-direction: normal;
        flex-direction: column;
right: 5px;
position: absolute;
}
#modal_models .agile__dot {
margin: 5px 0;
list-style-type: none;
}
#modal_models .agile__dot button {
background-color: transparent;
border: 1px solid #000;
cursor: pointer;
display: block;
height: 12px;
width: 12px;
font-size: 0;
line-height: 0;
margin: 0;
padding: 0;
-webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
}
#modal_models .agile__dot--current button, #modal_models .agile__dot:hover button {
background-color: #000;
}

#modal_models .slide {
display: block;
/* height: 500px; */
text-align: center;
min-height: 100px;
-o-object-fit: cover;
   object-fit: cover;
}
#modal_models .slide img{
  max-height: 455px;
  /* width: 100%; */
}
</style>
